import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { keyBy } from 'lodash';
import {
  withStyles,
  Menu,
  MenuItem,
  IconButton,
  Icon,
  Tooltip,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { setSelectedView } from '@pingum/app-state-management/dashboard/actions';
import {
  getQueryParam,
  setQueryParam,
} from '../../../../utils/urlHelper';
import defaultViews from './defaultViews';
import styles from './styles';

export class DashboardViewSelectorComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { menuElement: null };

    const view = keyBy(defaultViews, 'key')[getQueryParam('view')];
    if (view) {
      // props.setSelectedView(view);
    }
  }

  handleChange = (event) => {
    this.props.setSelectedView(event.target.value);
    setQueryParam('view', event.target.value.key);
  }

  handleClick = (event) => {
    this.setState({ menuElement: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ menuElement: null });
  }

  render() {
    const {
      views,
      selectedView,
    } = this.props;

    const { menuElement } = this.state;

    return (
      <div>

        <Tooltip title="View">
          <IconButton
            aria-owns={menuElement
              ? 'dashboard-view-menu'
              : null}
            aria-haspopup="true"
            name="dashboard-view-menu"
            color="inherit"
            onClick={this.handleClick}
          >
            <Icon>{selectedView.icon}</Icon>
          </IconButton>
        </Tooltip>
        <Menu
          id="dashboard-view-menu"
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this.handleClose}
        >
          {
            views.map((view) => (
              <MenuItem
                key={`view-${view.name}`}
                value={view}
                onClick={() => {
                  this.props.setSelectedView(view);
                  setQueryParam('view', view.key);
                  this.handleClose();
                }}
              >

                <ListItemIcon>
                  <Icon>{view.icon}</Icon>
                </ListItemIcon>
                <ListItemText style={{ padding: 0 }}>{view.name}</ListItemText>
              </MenuItem>
            ))
          }
        </Menu>
      </div>
    );
  }
}

DashboardViewSelectorComponent.propTypes = {
  views: PropTypes.array,
  setSelectedView: PropTypes.func,
  selectedView: PropTypes.object,
};

DashboardViewSelectorComponent.defaultProps = {
  views: defaultViews,
  setSelectedView: () => {},
  selectedView: {},
};

export const mapStateToProps = (state) => ({ selectedView: state.dashboard.selectedView });

export const mapDispatchToProps = (dispatch) => ({ setSelectedView: (view) => dispatch(setSelectedView(view)) });

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardViewSelectorComponent));
